/**
 * 微信oauth授权跳转
 * @param {String} appId 公众号appId
 * @param {String} redirectUrl 授权后回调页面完整地址（url必须encodeURIComponent）
 * @param {String} scope 授权类型 snsapi_base / snsapi_userinfo
 */
export function goWxAuth(appId, redirectUrl, scope = 'snsapi_base') {
    const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${encodeURIComponent(redirectUrl)}&response_type=code&scope=${scope}&state=STATE#wechat_redirect`
    window.location.href = url
}

/**
 * 获取url上的code参数
 */
export function getUrlCode() {
    const search = window.location.search.slice(1)
    const params = new URLSearchParams(search)
    return params.get('code')
}

/**
 * 判断是否 iOS 微信环境
 */
export function isIosWeChat() {
    const ua = navigator.userAgent.toLowerCase()
    return /iphone|ipad|ipod/.test(ua) && /micromessenger/.test(ua)
}

/**
 * 获取参与签名的url
 * iOS使用首次进入页面的原始链接，安卓使用当前页面链接
 */
export function getSignUrl() {
    if (isIosWeChat()) {
        // iOS 固定取初始化缓存的入口地址
        return window.__wxEntryUrl
    } else {
        // 安卓取当前完整地址，截断hash
        const href = window.location.href
        return href.includes('#') ? href.split('#')[0] : href
    }
}